import { render } from "./StepTipo.vue?vue&type=template&id=26683984"
import script from "./StepTipo.vue?vue&type=script&lang=js"
export * from "./StepTipo.vue?vue&type=script&lang=js"

import "./StepTipo.vue?vue&type=style&index=0&id=26683984&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__